export default "__VITE_ASSET__d401949e__"